export enum AnnouncementTypeEnum {
  MAINTENANCE = 'maintenance',
  GENERIC = 'generic',
}
